/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
export interface MitekUpdateModel {
  status: MitekUpdateStatus;
  result?: MitekUpdateResultModel;
}

export type MitekUpdateStatus = 'start' | 'acquiring' | 'success';

export interface MitekUpdateResultModel {
  docType?: string;
  imageData?: string;
  mode?: string;
  status?: string;
  warnings?: { status?: string };
}
